import styled from 'styled-components';

export const Grid = styled.div`
  display: grid;
  transition: all 0.2s;
  grid-template-columns: auto 5fr;
  width: 100vw;
  height: 100vh;
`;

export const Informations = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - 81px);
  display: block;
  .leaflet-top.leaflet-right {
    display: none !important;
  }
`;

export const MarcaAgua = styled.img`
  position: fixed;
  right: 20px;
  bottom: 20px;
  opacity: 0.6;
  z-index: -1;
`;
